// 上线的接口
// 写死接口
// var apiUrl = location.origin
// var apiUrl = 'http://ztb.uxuepai.net'
var apiUrl = ''

// if(apiUrl.includes('127.0.0.1')){
//   apiUrl = "http://iztb.uxuepai.net";
// }

var cntextPath = "/bid";

//本地测试
// if(process.env.NODE_ENV==='development'){
  // apiUrl = "http://ztb.uxuepai.net";
  // console.warn('development：apiUrl: ', apiUrl)
  // apiUrl = "http://iztb.uxuepai.net";
// }

// 前端后缀
var webCntextPath = "/bidc"

function getBaseUrl() {
    var baseUrl = ""
    if (process.env.NODE_ENV === "production") {
        baseUrl = webCntextPath
    }
    return baseUrl;
}

//var version = "dev";
var version = "";

function getVersion() {
    return version;
}

export {
    apiUrl,
    cntextPath,
    getBaseUrl,
    getVersion
}



// WEBPACK FOOTER //
// ./src/api/requestUrl.js